/**
 * NOTE: This mixin only works for single component
*/
export default {
  data () {
    return {
      screenWidth: window.innerWidth,
      componentKey: 0
    }
  },

  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },

  methods: {
    handleResize() {
      this.screenWidth = window.innerWidth;
    },

    forceRerender () {
      this.componentKey += 1
    }
  },

  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },

  watch: {
    screenWidth () {
      this.forceRerender()
    }
  }
}
